import { Injectable, TransferState, makeStateKey } from "@angular/core";

const CONTENT_KEY = makeStateKey('content');

@Injectable()
export class MktContentStorageService {

  private _content: any = {};
  private _cache: any = {};
  constructor(private state: TransferState) {
    this._content = this.state.get(CONTENT_KEY, {} as any);
  }

  public set(appId: string, content: any) {

    if (this._content[appId]) {
      var data1 = this._content[appId];
      var data2 = content;
      var data3 = this.mergeRecursive(data1, data2);
      var finalData = this.mergeDynamcicContentData(data3);
      this._content[appId] = finalData;
    } else {
      this._content[appId] = content;
    }
    this.state.set(CONTENT_KEY, this._content);
    this._cache[appId] = {};
  }

  public getKeys(data) {
    var keys = [];
    if (typeof data !== "undefined") {
      var nodes = data.split(".");
      for (var i = 0; i < nodes.length; i++) {
        keys.push(nodes[i]);
      }
    }
    return keys;
  }

  private getCacheKey(contentType: string, contentId: string, prop?: string, placeholdersObj?: any) {
    let key = contentType + '_' + contentId;
    if (typeof prop !== "undefined") {
      key = key + '_' + prop;
    }
    if (typeof placeholdersObj !== "undefined") {
      for (var objProp in placeholdersObj) {
        key = key + '_' + objProp + '_' + placeholdersObj[objProp];
      }
    }
    return key;
  }

  public get(appId: string, contentType: string, contentId: string, prop?: string, placeholdersObj?: any) {
    let cacheKey = this.getCacheKey(contentType, contentId, prop, placeholdersObj);
    if (this._cache[appId] && this._cache[appId][cacheKey]) {
      return this._cache[appId][cacheKey];
    }
    if (this._content[appId]) {
      if (this._content[appId][contentType + '$$' + contentId]) {
        if (typeof prop === "undefined") {
          return this._content[appId][contentType + '$$' + contentId];
        }
        let content, contentObj;
        var keys = this.getKeys(prop);
        if (keys.length > 1) {
          try {
            contentObj = JSON.parse(this._content[appId][contentType + '$$' + contentId][keys[0]]);
          } catch (e) {
            contentObj = this._content[appId][contentType + '$$' + contentId][keys[0]];
          }
          for (var i = 1; i < keys.length; i++) {
            if (typeof contentObj !== 'undefined' && contentObj != null && contentObj[keys[i]]) {
              try {
                contentObj = JSON.parse(contentObj[keys[i]]);
              } catch (e) {
                contentObj = contentObj[keys[i]];
              }
            }
            else {
              contentObj = undefined;
            }
          }
          content = contentObj;
        }
        else {
          contentObj = this._content[appId][contentType + '$$' + contentId][prop];
          try {
            content = JSON.parse(contentObj);
          } catch (e) {
            //Is not a json object, it means it is a string
            content = contentObj;
          }
        }

        if (placeholdersObj && typeof content === "string") {
          let placeholderArr: string[] = Object.keys(placeholdersObj);
          for (let placeholder of placeholderArr) {
            content = content.replace('{{' + placeholder + '}}', placeholdersObj[placeholder]);
          }
        }
        this._cache[appId][cacheKey] = content;
        return content;
      }
    }
    return undefined;
  }

  public getByAppId(appId: string): any {
    return this._content[appId];
  }

  private mergeRecursive(obj1, obj2) {
    //iterate over all the properties in the object which is being consumed
    for (var p in obj2) {
      if (obj1.hasOwnProperty(p) && typeof obj1[p] === "object") {
        obj1[p] = this.mergeRecursive(obj1[p], obj2[p]);
      } else {
        obj1[p] = obj2[p];
      }
    }
    return obj1;
  }

  private mergeDynamcicContentData(dat) {
    var result = {}; // This will be the merged object
    var keys = Object.keys(dat); // Contains keys
    while (keys.length) {
      var i = 1;
      for (; i < keys.length; i++) { // Find matches
        if (keys[0] == keys[i] + '$$$d') { // Match type 1
          result[keys[i]] = dat[keys[i]]; // Copy orig
          for (var j in dat[keys[0]]) { // Replace values
            result[keys[i]][j] = dat[keys[0]][j];
          }
          keys.splice(i, 1);
          keys.shift();
          i = 0;
          break;
        } else if (keys[i] == keys[0] + '$$$d') { // Reverse matched
          result[keys[0]] = dat[keys[0]];
          for (var j in dat[keys[i]]) {
            result[keys[0]][j] = dat[keys[i]][j];
          }
          keys.splice(i, 1);
          keys.shift();
          i = 0;
          break;
        }
      }
      if (i > 0) { // Didn't find a match
        result[keys[0]] = dat[keys[0]];
        keys.shift();
      }
    }
    return result;
  }
}
